export interface ConversationState {
    isReady                 : boolean;
    conversation            : any;
    messages                : any;
    error?                  : any;
}

export const CONVERSATION_INIT_STATE: ConversationState = {
    isReady                 : false,
    conversation            : null,
    messages                : null,
    error                   : null,
};
